import { createAction, createSlice } from '@reduxjs/toolkit';
import { set as _set } from 'lodash';
import { resetReducer } from '../../reduxStore/actions/actions';

export interface ISignupState {
	name?: string;
	lastname?: string;
	email?: string;
	select?: string;
}

const initialState: ISignupState = {};

export const signupSlice = createSlice({
	name: 'signup',
	initialState,
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(boxAction, (state, action) =>
				_set(state, action.payload.id, action.payload.value)
			)
			.addCase(resetReducer, () => initialState)
			.addDefaultCase((state, action) => {}),
});

const boxAction = createAction<{ id: string; value: any }>('@box/form/update');
